import axios from 'axios';
import apiConfig from '../api.config';

export default function updateSalesChannelRequest(id, enabled, clientId) {
  const {
    host,
    URIs: { updateSalesChannel },
  } = apiConfig;

  const uri = `${host}${updateSalesChannel}`.replace(':id', id);

  return axios
    .put(uri, JSON.stringify({ enabled, clientId }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
